import { createSelector } from '@reduxjs/toolkit';
import { ReportDone5SAuditState } from '../../types/reportDone5SAudit';

const selectSlice = (state: any): ReportDone5SAuditState => state.myTasksStrapi.reportDone5SAudit;

export const selectReportDoneData = createSelector([selectSlice], (s) => s.data);
export const selectReportDoneLoading = createSelector([selectSlice], (s) => s.loading);
export const selectReportDoneError = createSelector([selectSlice], (s) => s.error);
